import React from 'react';
import {
  Button,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
} from '@axiom/ui';
import type { Candidate, Education } from '@axiom/validation';

import { CandidateApi } from '../../api/candidate-api';
import { EducationApi } from '../../api/education-api';
import { CandidateProfileIssuesApi } from '../../api/candidate-profile-issues-api';

export const EducationDeleteModal = ({
  candidateId,
  educationId,
  onClose,
}: {
  candidateId: Candidate['id'];
  educationId: Education['id'];
  onClose: () => void;
}) => {
  return (
    <Modal name="EDUCATION_DELETE_MODAL">
      <ModalHeader name="EDUCATION_DELETE_MODAL_HEADER" onClose={onClose}>
        Delete This Education
      </ModalHeader>
      <ModalSection>
        Deleting this education removes it from your Axiom for Talent Profile
        and the bio that Axiom shares with prospective clients.
      </ModalSection>
      <ModalFooter>
        <Button variation="outline" name="CANCEL" onClick={onClose}>
          Cancel
        </Button>
        <Button
          name="SUBMIT"
          onClick={async () => {
            await EducationApi.deleteEducation(educationId);
            await CandidateApi.refreshCandidate(candidateId);
            await CandidateProfileIssuesApi.refreshCandidateProfileIssues(
              candidateId
            );
            onClose();
          }}
        >
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};
